export default __webpack_public_path__ + "static/media/beerstation_pub.794c1be6.jpg";